import script from "./DonationTransaction.vue?vue&type=script&setup=true&lang=js"
export * from "./DonationTransaction.vue?vue&type=script&setup=true&lang=js"

import "./DonationTransaction.vue?vue&type=style&index=0&id=37b897a1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37b897a1"]])

export default __exports__